import { render, staticRenderFns } from "./ReviewDingpanAuction.vue?vue&type=template&id=28a96251&scoped=true"
import script from "./ReviewDingpanAuction.vue?vue&type=script&lang=js"
export * from "./ReviewDingpanAuction.vue?vue&type=script&lang=js"
import style0 from "./ReviewDingpanAuction.vue?vue&type=style&index=0&id=28a96251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a96251",
  null
  
)

export default component.exports